// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as MouseButton from "./MouseButton.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function buttonToInt(button) {
  switch (button) {
    case "Main" :
      return 1;
    case "Auxiliary" :
      return 4;
    case "Secondary" :
      return 2;
    case "Fourth" :
      return 8;
    case "Fifth" :
      return 16;
  }
}

function toInt(buttons) {
  return Stdlib_Array.reduce(Belt_Set.toArray(buttons), 0, (n, x) => n + buttonToInt(x) | 0);
}

function fromInt(n) {
  if (n !== 0) {
    if (n !== 1) {
      if (n >= 2 && n < 4) {
        return Stdlib_Option.map(fromInt(n - 2 | 0), set => Belt_Set.add(set, "Secondary"));
      } else if (n >= 4 && n < 8) {
        return Stdlib_Option.map(fromInt(n - 4 | 0), set => Belt_Set.add(set, "Auxiliary"));
      } else if (n >= 8 && n < 16) {
        return Stdlib_Option.map(fromInt(n - 8 | 0), set => Belt_Set.add(set, "Fourth"));
      } else if (n >= 16 && n < 32) {
        return Stdlib_Option.map(fromInt(n - 16 | 0), set => Belt_Set.add(set, "Fifth"));
      } else {
        return;
      }
    } else {
      return Primitive_option.some(Belt_Set.fromArray(["Main"], MouseButton.Cmp));
    }
  } else {
    return Primitive_option.some(Belt_Set.make(MouseButton.Cmp));
  }
}

function fromEvent(e) {
  return fromInt(e.buttons);
}

function fromPointerEvent(e) {
  return fromInt(e.buttons);
}

export {
  buttonToInt,
  toInt,
  fromInt,
  fromEvent,
  fromPointerEvent,
}
/* MouseButton Not a pure module */
